import { error404 } from './404';
import { error500 } from './500';
import { ErrorPage } from '@/types';

export const errorPages: { [key: string]: ErrorPage } = { error404, error500 };
